export default defineAppConfig({
  title: 'Hello Nuxt',
});
